<template>
  <div
    class="base-typography"
    :class="{
      [`base-typography--type-${props.type}`]: true,
      'base-typography--nowrap': props.nowrap,
      'base-typography--with-pre-line': props.withPreLine,
    }"
    :style="{ fontWeight: props.weight, textAlign: props.textAlign }"
  >
    <slot />
  </div>
</template>

<script setup lang="ts">
interface Props {
  type?: 'h1'
    | 'h2'
    | 'h3'
    | 'h4'
    | 'h5'
    | 'h6'
    | 'title'
    | 'subtitle'
    | 'text'
    | 'text-secondary'
    | 'text-mini'
    | 'text-mini-alt'
    | 'caption'
    | 'label'
  color?: string
  weight?: string
  nowrap?: boolean
  withPreLine?: boolean
  textAlign?: 'left' | 'center' | 'right'
  width?: string
}

const props = withDefaults(defineProps<Props>(), {
  type: 'text',
  color: 'var(--color-foreground-regular)',
  withPreLine: false,
  width: '100%',
})
</script>

<style lang="scss" scoped>
.base-typography {
  display: inline-block;
  width: v-bind(width);
  color: var(--typography-color, v-bind(color));
  white-space: pre-line;

  &--type {
    &-h1 {
      @include typo-h1;
    }

    &-h2 {
      @include typo-h2;
    }

    &-h3 {
      @include typo-h3;
    }

    &-h4 {
      @include typo-h4;
    }

    &-h5 {
      @include typo-h5;
    }

    &-h6 {
      @include typo-h6;
    }

    &-title {
      @include typo-title;
    }

    &-subtitle {
      @include typo-subtitle;
    }

    &-text {
      @include typo-text;
    }

    &-text-secondary {
      @include typo-text-secondary;
    }

    &-text-mini {
      @include typo-text-mini;
    }

    &-text-mini-alt {
      @include typo-text-mini-alt;
    }

    &-caption {
      @include typo-caption;
    }

    &-label {
      @include typo-label;
    }
  }

  &--nowrap {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  &--with-pre-line {
    white-space: pre-line;
    word-break: break-word;
  }
}
</style>
